/* „Pe scurt" — comutarea intre functii, si disciplina de descarcare.
 *
 * Regula de baza, ca peste tot in tema: nimic de aici n-are voie sa arunce o
 * eroare care sa opreasca pagina.
 */
(function () {
  'use strict';

  var REDUCED = false;
  try {
    REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    /* ignoram */
  }

  function init(root) {
    if (root.__lnxhReady) return;
    root.__lnxhReady = true;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lnxh-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lnxh-panel]'));
    if (!tabs.length) return;

    var armed = false;

    /* Sursele se pun abia cand sectiunea se apropie de ecran. Altfel am descarca
       cinci clipuri pentru cineva care nu ajunge niciodata pana aici. */
    function arm() {
      if (armed || REDUCED) return;
      armed = true;
      panels.forEach(function (p) {
        var v = p.querySelector('.lnxh__video');
        if (v && !v.getAttribute('src')) {
          var s = v.getAttribute('data-lnxh-src');
          if (s) v.setAttribute('src', s);
        }
      });
      play(current());
    }

    function current() {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].getAttribute('aria-selected') === 'true') return i;
      }
      return 0;
    }

    function play(i) {
      panels.forEach(function (p, j) {
        var v = p.querySelector('.lnxh__video');
        if (!v) return;
        if (j === i && armed && !REDUCED && !document.hidden) {
          var pr = v.play();
          if (pr && pr.then) {
            pr.then(function () {
              v.classList.add('is-playing');
            }).catch(function () {
              /* autoplay refuzat: ramane posterul, ceea ce e o degradare acceptabila */
            });
          }
        } else {
          try {
            v.pause();
          } catch (e) {
            /* ignoram */
          }
          v.classList.remove('is-playing');
        }
      });
    }

    function select(i) {
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        t.setAttribute('tabindex', j === i ? '0' : '-1');
      });
      panels.forEach(function (p, j) {
        if (j === i) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      play(i);
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        select(i);
      });
      /* pe desktop, trecerea cu mausul e de ajuns — dar numai dupa ce sursele
         sunt puse, ca sa nu declansam descarcari din greseala */
      t.addEventListener('mouseenter', function () {
        if (armed && window.innerWidth >= 990) select(i);
      });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (n === null) return;
        e.preventDefault();
        select(n);
        tabs[n].focus();
      });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) play(-1);
      else play(current());
    });

    try {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              arm();
              play(current());
            } else {
              play(-1);
            }
          });
        },
        { rootMargin: '400px 0px' }
      );
      io.observe(root);
    } catch (e) {
      arm(); /* fara IntersectionObserver, incarcam direct */
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lnxh]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* editorul de tema re-randeaza sectiunea fara sa reincarce pagina */
  document.addEventListener('shopify:section:load', boot);
})();
